export const VALIDATION_ERROR = "VALIDATION_ERROR";
export const DATA_UPDATED = "DATA_UPDATED";
export const ENTITAS_UNIT = "ENTITAS_UNIT";
export const ALL_ENTITAS = "ALL_ENTITAS";
export const SET_LOADING = "SET_LOADING";
export const USERS_ENTITAS = "USERS_ENTITAS";
export const USERS_ENTITAS_UPDATED = "USERS_ENTITAS_UPDATED";
export const UNIT_OF_USERS_ENTITAS = "UNIT_OF_USERS_ENTITAS";
